import React, { useEffect, useRef, useState } from "react";

import "./dropdown.css";

const Dropdown = (props) => {

  const [active, setActive] = useState(false);
  const dropdown_toggle_el = useRef(null);
  const dropdown_content_el = useRef(null);

  useEffect(() => {
    const handleMouseDown = (event) => {
      if (dropdown_toggle_el.current?.contains(event.target)) {
        setActive((wasActive) => !wasActive);
      } else if (!dropdown_content_el.current?.contains(event.target)) {
        setActive(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, []);

  return (
    <div className={`dropdown ${props.small && "small"}`}>
      <button ref={dropdown_toggle_el} className="dropdown__toggle">
        {props.icon ? <i className={props.icon}></i> : ""}
        {props.badge ? (
          <span className="dropdown__toggle-badge">{props.badge}</span>
        ) : (
          ""
        )}
        {props.customToggle ? props.customToggle() : ""}
      </button>
      <div
        ref={dropdown_content_el}
        className={`dropdown__content ${active ? "active" : ""}`}
      >
        {!props.small && props.small === undefined ? (
          <>
            {props.contentData && props.renderItems
              ? props.contentData.map((item, index) =>
                  props.renderItems(item, index)
                )
              : ""}
            {props.renderFooter ? (
              <div className="dropdown__footer">{props.renderFooter()}</div>
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            <div>{props.contentData && props.contentData}</div>
            <div className="dropdown__footer">{props.renderFooter}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
